exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pg-ps-main-tab-div .nav-tabs {\n  background-color: #f1f5f8 !important;\n  color: #3d4852 !important;\n}\n.pg-ps-main-tab-div .nav-tabs .nav-link {\n  border: none !important;\n  color: #3d4852 !important;\n}\n.pg-ps-main-tab-div .nav-tabs .nav-link.active {\n  background-color: transparent !important;\n  border-bottom: 2px solid #01b1af !important;\n  color: #01b1af !important;\n}\n", ""]);

// exports
